import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname.startsWith('/pasteladmin')) {
      localStorage.removeItem('admin_token');
      window.location.href = '/pasteladmin/login';
    }
    return Promise.reject(error);
  }
);

// Cities
export const getCities = (activeOnly = false) => 
  api.get(`/cities${activeOnly ? '?active_only=true' : ''}`);

export const getCityBySlug = (slug) => 
  api.get(`/cities/slug/${slug}`);

export const createCity = (data) => 
  api.post('/cities', data);

export const updateCity = (id, data) => 
  api.put(`/cities/${id}`, data);

export const deleteCity = (id) => 
  api.delete(`/cities/${id}`);

// Categories
export const getCategories = (activeOnly = false) => 
  api.get(`/categories${activeOnly ? '?active_only=true' : ''}`);

export const createCategory = (data) => 
  api.post('/categories', data);

export const updateCategory = (id, data) => 
  api.put(`/categories/${id}`, data);

export const deleteCategory = (id) => 
  api.delete(`/categories/${id}`);

// Packages
export const getPackages = (activeOnly = false) => 
  api.get(`/packages${activeOnly ? '?active_only=true' : ''}`);

export const createPackage = (data) => 
  api.post('/packages', data);

export const updatePackage = (id, data) => 
  api.put(`/packages/${id}`, data);

export const deletePackage = (id) => 
  api.delete(`/packages/${id}`);

// Businesses
export const getBusinesses = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/businesses${queryString ? '?' + queryString : ''}`);
};

export const getBusinessesCount = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/businesses/count${queryString ? '?' + queryString : ''}`);
};

export const getBusinessById = (id, trackView = false) => 
  api.get(`/businesses/${id}${trackView ? '?track_view=true' : ''}`);

export const getBusinessBySlug = (citySlug, businessSlug, trackView = false) => 
  api.get(`/businesses/slug/${citySlug}/${businessSlug}${trackView ? '?track_view=true' : ''}`);

export const createBusiness = (data) => 
  api.post('/businesses', data);

export const updateBusiness = (id, data) => 
  api.put(`/businesses/${id}`, data);

export const deleteBusiness = (id) => 
  api.delete(`/businesses/${id}`);

export const trackBusinessAction = (id, action) => 
  api.post(`/businesses/${id}/track/${action}`);

// Admin Dashboard
export const getDashboardStats = () => 
  api.get('/admin/dashboard');

export const getExpiringBusinesses = (days = 7) => 
  api.get(`/admin/expiring?days=${days}`);

// Settings
export const getSettings = () => 
  api.get('/settings');

export const updateSettings = (data) => 
  api.put('/settings', data);

// SEO
export const getSitemap = () => 
  api.get('/sitemap');

export default api;
